import React from 'react';
import Modal from './Modal';

const ConfirmModal = (props) => (
    <Modal visible={props.visible}>
    <div className="modal-header">
        <h5 className="modal-title">{props.title}</h5>
    </div>
    <div className="modal-body">
        {props.children}
    </div>
    <div className="modal-footer">
            <span>
                <button type="button" className="btn btn-secondary" onClick={props.onCancel}>
                    Cancel
                </button>
                {props.onOK && (
                    <>
                        &nbsp;
                        <button type="button" className="btn btn-primary" onClick={props.onOK}>
                            OK
                        </button>
                    </>
                )}
            </span>
    </div>
  </Modal>
);

export default ConfirmModal;